import './Nav.css.proxy.js';
/* src/components/Nav.svelte generated by Svelte v3.29.7 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	null_to_empty,
	safe_not_equal,
	space,
	text
} from "../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let div;
	let a0;
	let t0;
	let a0_class_value;
	let t1;
	let a1;
	let t2;
	let a1_class_value;
	let t3;
	let a2;
	let t4;

	return {
		c() {
			div = element("div");
			a0 = element("a");
			t0 = text("Home");
			t1 = space();
			a1 = element("a");
			t2 = text("About");
			t3 = space();
			a2 = element("a");
			t4 = text("GitHub Repo");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			a0 = claim_element(div_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			t0 = claim_text(a0_nodes, "Home");
			a0_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			a1 = claim_element(div_nodes, "A", { href: true, class: true });
			var a1_nodes = children(a1);
			t2 = claim_text(a1_nodes, "About");
			a1_nodes.forEach(detach);
			t3 = claim_space(div_nodes);
			a2 = claim_element(div_nodes, "A", { href: true, class: true });
			var a2_nodes = children(a2);
			t4 = claim_text(a2_nodes, "GitHub Repo");
			a2_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a0, "href", "/");
			attr(a0, "class", a0_class_value = "" + (null_to_empty(/*segment*/ ctx[0] === undefined ? "current" : "") + " svelte-puph20"));
			attr(a1, "href", "/about");
			attr(a1, "class", a1_class_value = "" + (null_to_empty(/*segment*/ ctx[0] === "about" ? "current" : "") + " svelte-puph20"));
			attr(a2, "href", "https://github.com/GiorgosK/svelte-page-transitions");
			attr(a2, "class", "float-right svelte-puph20");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, a0);
			append(a0, t0);
			append(div, t1);
			append(div, a1);
			append(a1, t2);
			append(div, t3);
			append(div, a2);
			append(a2, t4);
		},
		p(ctx, [dirty]) {
			if (dirty & /*segment*/ 1 && a0_class_value !== (a0_class_value = "" + (null_to_empty(/*segment*/ ctx[0] === undefined ? "current" : "") + " svelte-puph20"))) {
				attr(a0, "class", a0_class_value);
			}

			if (dirty & /*segment*/ 1 && a1_class_value !== (a1_class_value = "" + (null_to_empty(/*segment*/ ctx[0] === "about" ? "current" : "") + " svelte-puph20"))) {
				attr(a1, "class", a1_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { segment } = $$props;

	$$self.$$set = $$props => {
		if ("segment" in $$props) $$invalidate(0, segment = $$props.segment);
	};

	return [segment];
}

class Nav extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { segment: 0 });
	}
}

export default Nav;
//# sourceMappingURL=Nav.js.map
